import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  {
    path: "/community",
    name: authCodeMap.community,
    component: (): any => import("@/modules/router.vue"),
    redirect: "/community/deco",
    meta: {
      title: "运营管理",
      hidden: false,
      icon: "tree",
      needLogin: true,
      authCode: authCodeMap.community,
    },
    children: [
      // {
      //   path: authCodeMap.community_deco_index,
      //   name: authCodeMap.community_deco_index,
      //   component: (): any => import("@/modules/community/pages/index/index.vue"),
      //   meta: {
      //     title: "运营_装修管理_社区装修",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_deco_index,
      //   },
      // },
      // {
      //   path: authCodeMap.community_deco_tieba,
      //   name: authCodeMap.community_deco_tieba,
      //   component: (): any => import("@/modules/community/pages/tieba/index.vue"),
      //   meta: {
      //     title: "运营_装修管理_健康圈装修",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_deco_tieba,
      //   },
      // },
      // {
      //   path: authCodeMap.community_deco_index_comty_info,
      //   name: authCodeMap.community_deco_index_comty_info,
      //   component: (): any => import("@/modules/community/pages/comtyInfo/index.vue"),
      //   meta: {
      //     title: "装修_社区信息",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_deco_index_comty_info,
      //   },
      // },
      // {
      //   path: "deco",
      //   name: authCodeMap.community_deco,
      //   component: (): any => import("@/modules/community/pages/deco/index.vue"),
      //   meta: {
      //     title: "运营管理_社区装修",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_deco,
      //   },
      // },
      // {
      //   path: "audit",
      //   name: authCodeMap.community_audit,
      //   component: (): any => import("@/modules/community/pages/audit/index.vue"),
      //   meta: {
      //     title: "运营_装修管理_社区资料认证",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_audit,
      //   },
      // },
      // {
      //   path: "info",
      //   name: authCodeMap.community_info,
      //   component: (): any => import("@/modules/community/pages/info/index.vue"),
      //   meta: {
      //     title: "运营_装修管理_社区信息",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_info,
      //   },
      // },
      // {
      //   path: authCodeMap.community_lastinfo,
      //   name: authCodeMap.community_lastinfo,
      //   component: (): any => import("@/modules/community/pages/info/lastInfo.vue"),
      //   meta: {
      //     title: "运营_装修管理_社区审核信息",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_lastinfo,
      //   },
      // },
      // {
      //   path: authCodeMap.community_register,
      //   name: authCodeMap.community_register,
      //   component: (): any => import("@/modules/community/pages/registerCommunity/registerCommunity.vue"),
      //   meta: {
      //     title: "新建社区",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.community_register,
      //   },
      // },
    ],
  },
];
export default routes;
